/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import '@polymer/polymer/polymer-element.js';

const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `
<dom-module id="cs-shared-styles-animations-keyframes">
  <template>
    <style>
      /** * Entering Animations */
      @keyframes fadeIn {
        from {
          opacity: var(--cs-fade-in-from-value);
        }

        to {
          opacity: var(--cs-fade-in-to-value);
        }
      }

      @keyframes slideUpFadeIn {
        from {
          opacity: var(--cs-fade-in-from-value);
          transform: translateY(var(--cs-slide-up-from-value));
        }

        to {
          opacity: var(--cs-fade-in-to-value);
          transform: translateY(var(--cs-slide-up-to-value));
        }
      }

      @keyframes slideDownFadeIn {
        from {
          opacity: var(--cs-fade-in-from-value);
          transform: translateY(var(--cs-slide-down-from-value));
        }

        to {
          opacity: var(--cs-fade-in-to-value);
          transform: translateY(var(--cs-slide-down-to-value));
        }
      }

      @keyframes slideInLeftFadeIn {
        from {
          opacity: var(--cs-fade-in-from-value);
          transform: translateX(var(--cs-slide-left-from-value));
        }

        to {
          opacity: var(--cs-fade-in-to-value);
          transform: translateX(var(--cs-slide-left-to-value));
        }
      }

      @keyframes slideInRightFadeIn {
        from {
          opacity: var(--cs-fade-in-from-value);
          transform: translateX(var(--cs-slide-right-from-value));
        }

        to {
          opacity: var(--cs-fade-in-to-value);
          transform: translateX(var(--cs-slide-right-to-value));
        }
      }

      @keyframes scaleInFadeIn {
        from {
          opacity: var(--cs-fade-in-from-value);
          transform: scale(var(--cs-scale-in-from-value));
        }

        to {
          opacity: var(--cs-fade-in-to-value);
          transform: scale(var(--cs-scale-in-to-value));
        }
      }

      /** * Exiting Animations */
      @keyframes fadeOut {
        from {
          opacity: var(--cs-fade-out-from-value);
        }

        to {
          opacity: var(--cs-fade-out-to-value);
        }
      }

      @keyframes slideOutDownFadeOut {
        from {
          opacity: var(--cs-fade-out-from-value);
          transform: translateY(var(--cs-slide-down-to-value));
        }

        to {
          opacity: var(--cs-fade-out-to-value);
          transform: translateY(var(--cs-slide-down-from-value));
        }
      }

      @keyframes slideOutUpFadeOut {
        from {
          opacity: var(--cs-fade-out-from-value);
          transform: translateY(var(--cs-slide-up-to-value));
        }

        to {
          opacity: var(--cs-fade-out-to-value);
          transform: translateY(var(--cs-slide-up-from-value));
        }
      }

      @keyframes slideOutLeftFadeOut {
        from {
          opacity: var(--cs-fade-out-from-value);
          transform: translateX(var(--cs-slide-left-to-value));
        }

        to {
          opacity: var(--cs-fade-out-to-value);
          transform: translateX(var(--cs-slide-left-from-value));
        }
      }

      @keyframes slideOutRightFadeOut {
        from {
          opacity: var(--cs-fade-out-from-value);
          transform: translateX(var(--cs-slide-right-to-value));
        }

        to {
          opacity: var(--cs-fade-out-to-value);
          transform: translateX(var(--cs-slide-right-from-value));
        }
      }

      /** * Foreground Specific Animations */
      @keyframes slideDownFadeInFG {
        from {
          opacity: var(--cs-fade-in-from-value);
          transform: translate(-50%, var(--cs-fg-slide-down-from-value));
        }

        to {
          opacity: var(--cs-fade-in-to-value);
          transform: translate(-50%, var(--cs-fg-slide-down-to-value));
        }
      }

      @keyframes slideUpFadeInFG {
        from {
          opacity: var(--cs-fade-in-from-value);
          transform: translate(-50%, var(--cs-fg-slide-up-from-value));
        }

        to {
          opacity: var(--cs-fade-in-to-value);
          transform: translate(-50%, var(--cs-fg-slide-up-to-value));
        }
      }

      @keyframes slideInLeftFadeInFG {
        from {
          opacity: var(--cs-fade-in-from-value);
          transform: translate(var(--cs-fg-slide-left-from-value), -50%);
        }

        to {
          opacity: var(--cs-fade-in-to-value);
          transform: translate(var(--cs-fg-slide-left-to-value), -50%);
        }
      }

      @keyframes slideInRightFadeInFG {
        from {
          opacity: var(--cs-fade-in-from-value);
          transform: translate(var(--cs-fg-slide-right-from-value), -50%);
        }

        to {
          opacity: var(--cs-fade-in-to-value);
          transform: translate(var(--cs-fg-slide-right-to-value), -50%);
        }
      }

      @keyframes slideOutLeftFadeOutFG {
        from {
          opacity: var(--cs-fade-out-from-value);
          transform: translate(var(--cs-fg-slide-left-to-value), -50%);
        }

        to {
          opacity: var(--cs-fade-out-to-value);
          transform: translate(var(--cs-fg-slide-left-from-value), -50%);
        }
      }

      @keyframes slideOutRightFadeOutFG {
        from {
          opacity: var(--cs-fade-out-from-value);
          transform: translate(var(--cs-fg-slide-right-to-value), -50%);
        }

        to {
          opacity: var(--cs-fade-out-to-value);
          transform: translate(var(--cs-fg-slide-right-from-value), -50%);
        }
      }

      @keyframes slideOutDownFadeOutFG {
        from {
          opacity: var(--cs-fade-out-from-value);
          transform: translate(-50%, var(--cs-fg-slide-down-to-value));
        }

        to {
          opacity: var(--cs-fade-out-to-value);
          transform: translate(-50%, var(--cs-fg-slide-down-from-value));
        }
      }

      @keyframes slideOutUpFadeOutFG {
        from {
          opacity: var(--cs-fade-out-from-value);
          transform: translate(-50%, var(--cs-fg-slide-up-to-value));
        }

        to {
          opacity: var(--cs-fade-out-to-value);
          transform: translate(-50%, var(--cs-fg-slide-up-from-value));
        }
      }

      /** * Component Specific Animations */
      @keyframes toasterIn {
        from {
          transform: translateY(600px);
        }

        to {
          transform: translateY(0);
        }
      }

      @keyframes toasterOut {
        from {
          transform: translateY(0);
        }

        to {
          transform: translateY(600px);
        }
      }
    </style>
  </template>
</dom-module>
`;

document.head.appendChild($_documentContainer.content);
